export default __webpack_public_path__ + "static/eds-blossom-99327b91c64a49d68497da00dccfae3b.png";